import { Injectable, inject } from '@angular/core';
import { Observable, map, of } from 'rxjs';

import { ImpersonationService } from '../../impersonation/impersonation.service';
import { X_ON_BEHALF_OF_HEADER } from '../../impersonation/internal/impersonation.interceptor';
import { ACCESS_TOKEN_PROVIDER, AccessTokenProvider } from '../access-token.provider';

import { AUTHORIZATION_HEADER } from './access-token-error-handler.service';

export interface AuthHeaders {
    [AUTHORIZATION_HEADER]?: string;
    [X_ON_BEHALF_OF_HEADER]?: string;
}

/**
 * Only used by mcm-viewer-rwc in mcm-monorepo.
 */
@Injectable({ providedIn: 'root' })
export class AuthHeaderService {
    #impersonationService = inject(ImpersonationService);
    #accessTokenProvider = inject<AccessTokenProvider>(ACCESS_TOKEN_PROVIDER, { optional: true });

    readonly authHeadersChanged$: Observable<AuthHeaders> = (
        this.#accessTokenProvider?.accessTokenChanged$ || of('')
    ).pipe(map(accessToken => this.#toAuthHeaders(accessToken, this.#impersonationService.onBehalfOf)));

    #toAuthHeaders(accessToken?: string, onBehalfOf?: string | null): AuthHeaders {
        const headers: AuthHeaders = {};
        if (accessToken) {
            headers[AUTHORIZATION_HEADER] = `Bearer ${accessToken}`;
        }
        if (onBehalfOf) {
            headers[X_ON_BEHALF_OF_HEADER] = onBehalfOf;
        }
        return headers;
    }
}
